import React from 'react';
import cx from 'classnames';
import { ReactComponent as LoadingComponent } from '@THC/assets/svgs/loading.svg';
import { filterDataProps } from '@THC/utils/helpers';
import { VisuallyHidden } from '../__primitives__/VisuallyHidden';
import styles from './LoadingIndicator.module.scss';
export const LoadingArrow = ({ showText, size = 'small', text = 'Loading', ...rest }) => (<span className={cx(styles.loadingIndicator, styles.arrow, styles[size])} role="status" {...filterDataProps(rest)}>
		<LoadingComponent />
		{showText ? <span className={styles.text}>{text}</span> : <VisuallyHidden>{text}</VisuallyHidden>}
	</span>);
